import { render, staticRenderFns } from "./NavbarAccountsMenu.vue?vue&type=template&id=810f93c6"
import script from "./NavbarAccountsMenu.vue?vue&type=script&lang=js"
export * from "./NavbarAccountsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports